// libs
import { create } from 'zustand';
// constants
import { INITIAL_STATE } from '@/stores/SuggestedKeywords/constants';
const useSuggestedKeywordsStore = create((set, get) => (Object.assign(Object.assign({}, structuredClone(INITIAL_STATE)), { setKeywords: (keywords) => set({ keywords: structuredClone(keywords) }), setCustomKeywords: (keywords) => set({ customKeywords: structuredClone(keywords) }), appendCustomKeywords: (keywords) => {
        const currentCustomKeywords = get().customKeywords;
        set({
            customKeywords: structuredClone([
                ...currentCustomKeywords,
                ...keywords,
            ]),
        });
    }, clearKeywords: () => set(Object.assign({}, structuredClone(INITIAL_STATE))) })));
export default useSuggestedKeywordsStore;
